export const UI = {
  id: {
    nav: {
      home: "Beranda", services: "Layanan Psikologi", psychologists: "Psikolog",
      assessment: "Asesmen Psikologi", programs: "Program", mentalHealth: "Kesehatan Mental",
      answers: "Tanya Jawab", faq: "FAQ", location: "Lokasi", contact: "Kontak",
    },
    cta: {
      book: "Buat Janji Konsultasi", whatsapp: "Hubungi Kami di WhatsApp", whatsappShort: "WhatsApp",
      findService: "Temukan Layanan yang Sesuai", explore: "Lihat Semua Layanan",
      meetTeam: "Kenali Psikolog Kami", learnMore: "Selengkapnya", bookShort: "Buat Janji",
    },
    hero: {
      h1: "Psikolog & Layanan Konseling Profesional di Denpasar, Bali",
      sub: "Dapatkan dukungan psikologis profesional untuk diri Anda, hubungan Anda, anak Anda, atau keluarga Anda. Bali Empower menyediakan konseling personal, asesmen psikologi, dan program kesehatan mental terstruktur dalam lingkungan yang privat dan suportif.",
      trust: "Dukungan psikologis profesional di Denpasar, Bali untuk individu, pasangan, anak, remaja, dan keluarga.",
    },
    trustBar: ["Tenaga profesional psikologi", "Pendekatan berbasis bukti", "Konsultasi privat", "Pendampingan personal", "Asesmen psikologi profesional", "Klinik lokal di Denpasar"],
    sections: {
      startHere: "Dukungan Seperti Apa yang Anda Cari?",
      problems: "Anda Tidak Harus Menghadapinya Sendirian",
      problemsSub: "Ini adalah beberapa hal yang sering menjadi alasan seseorang mencari dukungan psikologis.",
      why: "Dukungan Profesional. Pendekatan Personal.",
      how: "Memulai Itu Sederhana",
      team: "Kenali Tim Psikolog Kami",
      teamSub: "Profil lengkap tim profesional kami sedang disiapkan dan akan segera dilengkapi.",
      faq: "Pertanyaan yang Sering Diajukan",
      location: "Kunjungi Klinik Kami di Renon, Denpasar",
      finalCta: "Siap Mengambil Langkah Pertama?",
      finalCtaSub: "Membuat janji konsultasi hanya membutuhkan beberapa menit. Tim kami siap membantu Anda menemukan dukungan yang sesuai.",
    },
    why: [
      { t: "Tenaga Profesional Berkualifikasi", d: "Anda didampingi tenaga profesional psikologi yang berkualifikasi." },
      { t: "Pendampingan Personal", d: "Konsultasi Anda dirancang berdasarkan situasi dan tujuan pribadi Anda." },
      { t: "Praktik Berbasis Bukti", d: "Kami menggunakan pendekatan psikologis yang sesuai secara klinis dan berbasis bukti." },
      { t: "Lingkungan Privat & Suportif", d: "Ruang yang rahasia, aman, dan bebas dari penghakiman." },
      { t: "Akses yang Mudah", d: "Proses booking dan konsultasi dibuat sesederhana mungkin." },
      { t: "Pemahaman Lokal", d: "Dukungan psikologis profesional yang berakar di Denpasar, Bali." },
    ],
    steps: [
      { t: "Pilih Layanan Anda", d: "Temukan layanan yang paling sesuai dengan kebutuhan Anda." },
      { t: "Buat Janji Konsultasi", d: "Booking melalui website atau WhatsApp dalam hitungan menit." },
      { t: "Bertemu Psikolog Anda", d: "Sesi pertama berfokus pada mendengarkan cerita Anda." },
      { t: "Tinjau Kebutuhan & Tujuan", d: "Bersama psikolog, Anda memetakan kebutuhan dan tujuan." },
      { t: "Lanjutkan dengan Rencana Personal", d: "Pendampingan berlanjut sesuai rencana yang disepakati." },
    ],
    misc: {
      viewProfile: "Lihat Profil", bookWith: "Buat Janji", allServices: "Semua Layanan",
      whatIs: "Apa itu layanan ini?", whoFor: "Untuk siapa layanan ini?",
      whenConsider: "Kapan layanan ini perlu dipertimbangkan?",
      firstSession: "Apa yang terjadi pada sesi pertama?",
      duration: "Berapa lama satu sesi?", sessions: "Berapa banyak sesi yang dibutuhkan?",
      provider: "Siapa yang memberikan layanan?", format: "Apakah tersedia online atau tatap muka?",
      cost: "Berapa biayanya?", howBook: "Bagaimana cara membuat janji?",
      signs: "Tanda-tanda yang umum", whenSeek: "Kapan perlu dukungan profesional?",
      howHelp: "Bagaimana Bali Empower dapat membantu", relatedService: "Layanan terkait",
      shortAnswer: "Jawaban singkat", detail: "Penjelasan", backTo: "Kembali ke",
      address: "Alamat", phone: "Telepon", directions: "Petunjuk Arah di Google Maps",
      openMaps: "Buka di Google Maps", nearby: "Dekat kawasan Renon, pusat perkantoran Denpasar Selatan",
      readAnswer: "Baca jawaban", problem: "Masalah yang ditangani", forWho: "Untuk siapa",
      goals: "Tujuan program", structure: "Struktur program", langNote: "English version",
      placeholderTeam: "Profil akan dilengkapi oleh tim Bali Empower",
      contactTitle: "Hubungi Bali Empower", send: "Kirim Pesan",
      name: "Nama", email: "Email (opsional)", message: "Pesan", phoneField: "Nomor WhatsApp/Telepon",
      sent: "Pesan terkirim. Tim kami akan menghubungi Anda.",
      bookingTitle: "Buat Janji Konsultasi",
      bookingSub: "Lengkapi langkah berikut — kurang dari 2 menit. Tim kami akan mengonfirmasi jadwal Anda melalui WhatsApp.",
      stepService: "Pilih Layanan", stepPsych: "Pilih Psikolog", stepSchedule: "Pilih Jadwal",
      stepContact: "Data Kontak", stepConfirm: "Konfirmasi",
      anyPsych: "Psikolog mana pun (direkomendasikan tim)",
      date: "Tanggal", time: "Waktu yang diinginkan", next: "Lanjut", back: "Kembali",
      confirmBooking: "Konfirmasi Janji", bookingSuccess: "Permintaan janji Anda telah diterima!",
      bookingSuccessSub: "Tim Bali Empower akan mengonfirmasi jadwal Anda. Anda juga dapat mengirim detail booking langsung ke WhatsApp kami:",
      sendWa: "Kirim ke WhatsApp", scheduleNote: "Jadwal final akan dikonfirmasi oleh tim kami sesuai ketersediaan.",
      notes: "Catatan (opsional)", summary: "Ringkasan", service: "Layanan", psychologist: "Psikolog",
    },
    footer: {
      desc: "Bali Empower adalah klinik psikologi dan kesehatan mental di Renon, Denpasar Selatan, Bali — menyediakan konseling psikologi, asesmen psikologi, dan program kesehatan mental terstruktur untuk individu, pasangan, anak, remaja, dan keluarga.",
      services: "Layanan", resources: "Sumber Daya", clinic: "Klinik", legal: "Legal",
      privacy: "Kebijakan Privasi", terms: "Syarat & Ketentuan", cancellation: "Kebijakan Pembatalan",
    },
  },
  en: {
    nav: {
      home: "Home", services: "Psychology Services", psychologists: "Psychologists",
      assessment: "Psychological Assessment", programs: "Programs", mentalHealth: "Mental Health",
      answers: "Answers", faq: "FAQ", location: "Location", contact: "Contact",
    },
    cta: {
      book: "Book a Consultation", whatsapp: "WhatsApp Us", whatsappShort: "WhatsApp",
      findService: "Find the Right Service", explore: "Explore All Services",
      meetTeam: "Meet Our Psychologists", learnMore: "Learn More", bookShort: "Book",
    },
    hero: {
      h1: "Professional Psychologist & Counseling Services in Denpasar, Bali",
      sub: "Get professional psychological support for yourself, your relationship, your child, or your family. Bali Empower provides personalized counseling, psychological assessment and structured mental health programs in a private and supportive environment.",
      trust: "Professional psychological support in Denpasar, Bali for individuals, couples, children, adolescents and families.",
    },
    trustBar: ["Psychology professionals", "Evidence-informed approach", "Private consultation", "Individualized support", "Professional psychological assessment", "Local Denpasar clinic"],
    sections: {
      startHere: "What Kind of Support Are You Looking For?",
      problems: "You Do Not Have to Figure It Out Alone",
      problemsSub: "These are some of the most common reasons people seek psychological support.",
      why: "Professional Support. Personal Approach.",
      how: "Getting Started Is Simple",
      team: "Meet Our Psychologists",
      teamSub: "Full profiles of our professional team are being prepared and will be completed soon.",
      faq: "Frequently Asked Questions",
      location: "Visit Our Clinic in Renon, Denpasar",
      finalCta: "Ready to Take the First Step?",
      finalCtaSub: "Booking a consultation takes only a few minutes. Our team is ready to help you find the right support.",
    },
    why: [
      { t: "Qualified Professionals", d: "Work with qualified psychology professionals." },
      { t: "Personalized Support", d: "Your consultation is based on your individual circumstances and goals." },
      { t: "Evidence-Informed Practice", d: "We use clinically appropriate, evidence-informed psychological approaches." },
      { t: "Private & Supportive Environment", d: "A confidential, safe and non-judgmental setting." },
      { t: "Convenient Access", d: "Booking and consultation are kept as straightforward as possible." },
      { t: "Local Understanding", d: "Professional psychological support based in Denpasar, Bali." },
    ],
    steps: [
      { t: "Choose Your Service", d: "Find the service that best fits your needs." },
      { t: "Book Your Consultation", d: "Book via the website or WhatsApp within minutes." },
      { t: "Meet With Your Psychologist", d: "The first session focuses on listening to your story." },
      { t: "Review Your Needs and Goals", d: "Together, you map out your needs and goals." },
      { t: "Continue With a Personalized Plan", d: "Support continues according to an agreed plan." },
    ],
    misc: {
      viewProfile: "View Profile", bookWith: "Book Appointment", allServices: "All Services",
      whatIs: "What is this service?", whoFor: "Who is it for?",
      whenConsider: "When might someone consider it?",
      firstSession: "What happens during the first session?",
      duration: "How long is a session?", sessions: "How many sessions might be appropriate?",
      provider: "Who provides the service?", format: "Is it available online or in person?",
      cost: "What does it cost?", howBook: "How do I book?",
      signs: "Common signs", whenSeek: "When to consider professional support",
      howHelp: "How Bali Empower can help", relatedService: "Related service",
      shortAnswer: "Short answer", detail: "What this means", backTo: "Back to",
      address: "Address", phone: "Phone", directions: "Directions on Google Maps",
      openMaps: "Open in Google Maps", nearby: "Near the Renon area, Denpasar Selatan's government and office district",
      readAnswer: "Read answer", problem: "The problem it addresses", forWho: "Who it is for",
      goals: "Program goals", structure: "Program structure", langNote: "Versi Bahasa Indonesia",
      placeholderTeam: "Profile to be completed by the Bali Empower team",
      contactTitle: "Contact Bali Empower", send: "Send Message",
      name: "Name", email: "Email (optional)", message: "Message", phoneField: "WhatsApp/Phone number",
      sent: "Message sent. Our team will contact you.",
      bookingTitle: "Book a Consultation",
      bookingSub: "Complete the steps below — under 2 minutes. Our team will confirm your schedule via WhatsApp.",
      stepService: "Select Service", stepPsych: "Select Psychologist", stepSchedule: "Select Schedule",
      stepContact: "Contact Details", stepConfirm: "Confirm",
      anyPsych: "Any psychologist (team recommended)",
      date: "Date", time: "Preferred time", next: "Next", back: "Back",
      confirmBooking: "Confirm Appointment", bookingSuccess: "Your appointment request has been received!",
      bookingSuccessSub: "The Bali Empower team will confirm your schedule. You can also send your booking details directly to our WhatsApp:",
      sendWa: "Send to WhatsApp", scheduleNote: "Final schedule will be confirmed by our team based on availability.",
      notes: "Notes (optional)", summary: "Summary", service: "Service", psychologist: "Psychologist",
    },
    footer: {
      desc: "Bali Empower is a psychology and mental health clinic in Renon, Denpasar Selatan, Bali — providing psychological counseling, psychological assessment and structured mental health programs for individuals, couples, children, adolescents and families.",
      services: "Services", resources: "Resources", clinic: "Clinic", legal: "Legal",
      privacy: "Privacy Policy", terms: "Terms & Conditions", cancellation: "Cancellation Policy",
    },
  },
};

// Route path builders per language
export const PATHS = {
  id: {
    home: "/", services: "/layanan", service: (s) => `/layanan/${s}`,
    psychologists: "/psikolog", psychologist: (s) => `/psikolog/${s}`,
    assessment: "/asesmen-psikologi", programs: "/program", program: (s) => `/program/${s}`,
    mentalHealth: "/kesehatan-mental", topic: (s) => `/kesehatan-mental/${s}`,
    answers: "/jawaban", answer: (s) => `/jawaban/${s}`,
    faq: "/faq", location: "/lokasi", contact: "/kontak", booking: "/buat-janji",
    privacy: "/kebijakan-privasi", terms: "/syarat-ketentuan", cancellation: "/kebijakan-pembatalan",
  },
  en: {
    home: "/en", services: "/en/services", service: (s) => `/en/services/${s}`,
    psychologists: "/en/psychologists", psychologist: (s) => `/en/psychologists/${s}`,
    assessment: "/en/psychological-assessment", programs: "/en/programs", program: (s) => `/en/programs/${s}`,
    mentalHealth: "/en/mental-health", topic: (s) => `/en/mental-health/${s}`,
    answers: "/en/answers", answer: (s) => `/en/answers/${s}`,
    faq: "/en/faq", location: "/en/location", contact: "/en/contact", booking: "/en/book",
    privacy: "/en/privacy-policy", terms: "/en/terms", cancellation: "/en/cancellation-policy",
  },
};
